module.exports = __webpack_public_path__ + "img/LogoBeSchool_Gris.1938caf3.png";